import React from 'react'
import styled from 'styled-components'

export interface ItemProps {
  name: string
  value: string
}

const AmountItem: React.FC<ItemProps> = ({
  name = '',
  value = '',
  ...props
}): JSX.Element => {

  if (name === '') {
    return (
      <EmptyComponent>
      </EmptyComponent>
    ) 
  } else {
    const makeBold = name === "Estimated Responsibility" || name === "Estimated Responsibility - Enhanced Tier"
    return (
      <Component>
        {makeBold ? (<ItemNameBold>{name}</ItemNameBold>) : (<ItemName>{name}</ItemName>)}
        <ItemValue>{value}</ItemValue>
      </Component>
    )
  }
}

const EmptyComponent = styled.div`
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  > span {
    line-height: 30px;
  }
 `

const Component = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  > span {
    line-height: 30px;
  }
  padding: 10px;
`

const ItemName = styled.span`
  color: #89919C;
  font-size: 14px;
`

const ItemNameBold = styled.span`
  color: #152735;
  font-size: 14px;
  font-weight: bold;
`

const ItemValue = styled.span`
  color: #152735;
  font-size: 21px;
  font-weight: bold;
`

export default AmountItem
